module.exports = __webpack_public_path__ + "img/tooltip.41568a08.svg";